import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Box } from '@zillow/constellation';
import abtest from '@zillow/mortgage-abtest';
import Questionnaire from '@zillow/mortgage-questionnaire';
import { zillowURL } from '@zillow/url';
import React, { useState, useEffect, useMemo } from 'react';
import MortgagePageClassification from '../../utils/mortgagehelpers/MortgagePageClassification.js';
import { getMapObject, mapLongTableInput } from './MortgageQuestionnare.util.js';

var LOAN_TYPE_PURCHASE = 'purchase';
var ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT = 'ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT';
var ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT_VARIANT = 'VARIANT';
var QUOTES_PAGE_URL_PATH = "mortgage-rates/quotes/";
var MORTGAGE_QUESTIONNAIRE_KEY = 'mortgage-questionnaire';
var buildResultsUrl = function buildResultsUrl() {
  var _getMapObject;
  // Build the params using the mortgage-questionnaire localStorage key
  var storedAnswers = (_getMapObject = getMapObject(MORTGAGE_QUESTIONNAIRE_KEY)) !== null && _getMapObject !== void 0 ? _getMapObject : {};
  // If empty, return the /quotes URL without the added params
  if (Object.keys(storedAnswers).length === 0) {
    return zillowURL(QUOTES_PAGE_URL_PATH);
  }
  // Else, append the key values to the URL params to create a fresh requestId
  var newUrlParams = mapLongTableInput(storedAnswers);
  return zillowURL(QUOTES_PAGE_URL_PATH + ("?" + new URLSearchParams(newUrlParams).toString()));
};
var MortgageQuestionnaire = function MortgageQuestionnaire(_ref) {
  var pathName = _ref.pathName,
    landingPage = _ref.landingPage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    started = _useState2[0],
    setStarted = _useState2[1];
  useEffect(function () {
    var waitingOnOptimize = function waitingOnOptimize() {
      return new Promise(function ($return, $error) {
        return Promise.resolve(abtest.waitOnOptimize()).then(function ($await_1) {
          try {
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    };
    waitingOnOptimize();
  }, []);
  var classification = new MortgagePageClassification(pathName !== null && pathName !== void 0 ? pathName : '/mortgage-rates/');
  var loanType = classification.loanType;
  var resultsUrl = useMemo(function () {
    return buildResultsUrl();
  }, []);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'relative',
      padding: 'sm',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '@media $md': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }
  }, /*#__PURE__*/React.createElement(Questionnaire, {
    context: {
      entry: 'cq',
      originalEntry: 'cq',
      // title: header,
      // description: paraGraph,
      loanType: loanType,
      landingPage: landingPage !== null && landingPage !== void 0 ? landingPage : 'mortgage-rates',
      source: global.window && new URLSearchParams(window.location.search).get('source')
    },
    storageKey: MORTGAGE_QUESTIONNAIRE_KEY,
    onRouteChange: function onRouteChange(_ref2) {
      var lastKey = _ref2.lastKey,
        answers = _ref2.answers,
        isInit = _ref2.isInit;
      if (isInit) {
        return;
      }
      if (!started) {
        var _global$DD_RUM, _global$DD_RUM$addAct;
        setStarted(true);
        (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 || (_global$DD_RUM$addAct = _global$DD_RUM.addAction) === null || _global$DD_RUM$addAct === void 0 || _global$DD_RUM$addAct.call(_global$DD_RUM, 'mortgage-questionnaire:started', {
          entry: 'CQ',
          startedWith: lastKey
        });
      }
      abtest.getTreatment(ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT) === ZGMI_PURCHASE_RATES_ROUTING_IN_CONNECT_VARIANT && (answers === null || answers === void 0 ? void 0 : answers.loanType) === LOAN_TYPE_PURCHASE;
    },
    showProgress: false,
    showLanding: true,
    resultsUrl: resultsUrl
  }));
};
var MortgageQuestionnare = MortgageQuestionnaire;

export { MortgageQuestionnare as default };
